module.exports = __webpack_public_path__ + "static/media/sample_banner.ae5ea84d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/home/sample_banner.jpg
// module id = 1026
// module chunks = 0